import { highlight } from '../syntax-highlighter/syntax-highlighter'
import { CoreMustacheRenderers } from './shared'

const buildClassAttr = (classNames?: string) =>
  !!classNames ? ` class="${classNames}"` : ''

const rendererFactory =
  (tag: string, classNames?: string) => () => (text, render) =>
    `<${tag}${buildClassAttr(classNames)}>${render(text)}</${tag}>`

export const buildSyntaxHighlighter =
  (language: string) => () => (text, render) => {
    const renderedText = render(text)
    if (
      language === 'html' ||
      language === 'xml' ||
      language === 'csharp' ||
      language === 'java' ||
      language === 'javascript' ||
      language === 'ruby' ||
      language === 'python' ||
      language === 'php' ||
      language === 'go'
    ) {
      return '<pre>' + highlight(unescape(renderedText), language) + '</pre>'
    }
    return highlight(renderedText, language)
  }

export const mustacheRedactedClassname = 'mustache-redacted-content'

export const coreMustacheRenderers: CoreMustacheRenderers = {
  nl: '<br/>',
  omitted: rendererFactory('span', 'omitted'),
  taint: rendererFactory('span', 'tainted-data'),
  unstyledData: rendererFactory('span'),
  paragraph: rendererFactory('p'),
  unorderedList: rendererFactory('ul'),
  listElement: rendererFactory('li'),
  badConfig: () => (text, render) => `<font color="red">${render(text)}</font>`,
  goodConfig: () => (text, render) =>
    `<font color="green">${render(text)}</font>`,
  link: () => (text, render) => {
    const [url, content] = render(text).split('$$LINK_DELIM$$')
    return `<a href="${url}">${content}</a>`
  },
  redacted: rendererFactory('span', mustacheRedactedClassname),
  focus: rendererFactory('b'),
  quote: rendererFactory('div', 'quote'),
  block: rendererFactory('div'),
  // syntax highlighting for code blocks
  csharpBlock: buildSyntaxHighlighter('csharp'),
  javaBlock: buildSyntaxHighlighter('java'),
  javascriptBlock: buildSyntaxHighlighter('javascript'),
  rubyBlock: buildSyntaxHighlighter('ruby'),
  pythonBlock: buildSyntaxHighlighter('python'),
  phpBlock: buildSyntaxHighlighter('php'),
  goBlock: buildSyntaxHighlighter('go'),
  htmlBlock: buildSyntaxHighlighter('html'),
  xmlBlock: buildSyntaxHighlighter('xml')
}
